import { createSlice } from '@reduxjs/toolkit';
import { userApi } from '@/store/api/userApi';
import { UserProfile, WalletInfo } from '@/types/user';

interface AccountState {
  profile: UserProfile | null;
  wallet: WalletInfo;
}

const initialState: AccountState = {
  profile: null,
  wallet: {
    mainBalance: 0,
    bonusBalance: 0,
    exposure: 0,
    lockedAmount: 0,
  },
};

const isSameWallet = (current: WalletInfo, next: WalletInfo) => {
  return (
    current.mainBalance === next.mainBalance &&
    current.bonusBalance === next.bonusBalance &&
    current.exposure === next.exposure &&
    current.lockedAmount === next.lockedAmount
  );
};

export const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    resetAccount: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // Profile
      .addMatcher(userApi.endpoints.getUserProfile.matchFulfilled, (state, { payload }) => {
        state.profile = payload;
      })

      // Wallet
      .addMatcher(userApi.endpoints.getUserWallets.matchFulfilled, (state, { payload }) => {
        if (isSameWallet(state.wallet, payload)) {
          return;
        }

        state.wallet = payload;
      });
  },
});

export const { resetAccount } = accountSlice.actions;
